<template>
	<div>
    <div v-if="currentTemplate != null">
      <h2 class="view__title--sub">{{ L.localize("Campaign_ContentContinueTitle") }}</h2>
      <div class="cards">
        <div class="cards__item" v-for="template in currentTemplate" @click="selectLayout(template)">
          <img class="cards__image" :src="getCurrentImg(template)">
          <div class="cards__text">
            <p>{{ L.localize("Label_Current") }}</p>
          </div>
        </div>
      </div>
    </div>

    <h2 class="view__title--sub">{{ L.localize("Campaign_ContentTitle") }}</h2>
    <div class="cards">
      <div class="cards__item" v-for="template in usableTemplates" @click="selectTemplate(template)">
        <img class="cards__image" :src="getLayoutImg(template)">
        <div class="cards__text">
          <p>{{ template.name }}</p>
        </div>
      </div>
    </div>

    <h2 class="view__title--sub">{{ L.localize("Campaign_ContentSecondTitle") }}</h2>
    <div class="cards">
      <div class="cards__item" v-for="layout in layouts" @click="selectLayout(layout)">
        <img class="cards__image" :src="layout.img">
        <div class="cards__text">
          <p>{{ layout.title }}</p>
        </div>
      </div>
    </div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import L from 'services/Localization'

export default {
  name: 'campaign-content',
  props: {
    campaign: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      L: L
    }
  },
  computed: {
    ...mapGetters({
      templates: 'allTemplates',
      layouts: 'templateLayouts'
    }),
    usableTemplates() {
      return _.filter(this.templates, (template) => template.jsonContent !== null)
    },
    currentTemplate() {
      if (!_.isNull(this.campaign.config)) {
        return [this.campaign.config]
      }
      return null
    }
  },
  mounted() {
    this.$store.dispatch('getAllTemplates')
  },
  methods: {
    selectTemplate: function(template) {
      this.campaign.template = JSON.parse(template.jsonContent)
      this.campaign.showEditor = true
    },
    selectLayout: function(layout) {
      this.campaign.template = layout
      this.campaign.showEditor = true
    },
    getCurrentImg: function(template) {
      let parsedContent = JSON.parse(template)
      let layout = _.find(this.layouts, ['id', parsedContent.page.title])
      return layout.img
    },
    getLayoutImg: function(template) {
      let parsedContent = JSON.parse(template.jsonContent)
      let layout = _.find(this.layouts, ['id', parsedContent.page.title])

      if (layout === undefined) {
        return this.layouts[0].img
      }

      return layout.img
    }
  }
}
</script>

<style lang='scss'>

</style>



// WEBPACK FOOTER //
// CampaignContent.vue?95885568